// =============================================================================
// SHARE DONATION SCREEN - Екран створення посилання на збір (Tactical Design)
// =============================================================================

import { BaseCampaignForm } from './BaseCampaignForm';

interface ShareDonationScreenProps {
    onBack: () => void;
}

export function ShareDonationScreen({ onBack }: Readonly<ShareDonationScreenProps>) {
  return (
    <BaseCampaignForm
      onBack={onBack}
      campaignType="donation"
      ariaLabel="Створення збору"
      headerTitle="Створити збір"
      headerSubtitle="Згенеруйте посилання на гру з інтегрованим збором коштів"
      terminalLabel="МОДУЛЬ ІНТЕГРАЦІЇ ЗБОРУ"
      urlLabel="Посилання на банку (Monobank)"
      urlPlaceholder="https://send.monobank.ua/jar/..."
      urlMissingError="Введіть посилання на банку"
      urlInvalidError="Невірний формат посилання"
      urlDomainError="Підтримуються тільки посилання на Monobank"
      urlDomainCheck={(url) => url.includes('monobank.ua')}
      titleLabel="Назва збору (необов'язково)"
      titlePlaceholder="На дрони для 3 ОШБр"
      defaultTitle="ПІДТРИМАЙ ЗСУ"
      descriptionLabel="Опис (необов'язково)"
      descriptionPlaceholder="Короткий опис, на що саме збираємо..."
      footerText="Гравцю буде запропоновано підтримати збір в процесі гри"
    />
  );
}